<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in" v-if="!!approvedBillLines">
      <v-flex>
        <v-card>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <multi-actions page="approvedBillLines" :pagination="pagination" v-if="userAuthClass" :selectedCount="selectedCount"></multi-actions>
              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">

                <v-tooltip bottom v-if="selected.length > 0 && !selectedAll">
                  <v-btn
                    flat
                    color="grey"
                    icon
                    @click="selected = []; selectedAll = false"
                    slot="activator"
                  >
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>

                <v-tooltip
                  bottom
                  v-if="this.$store.state.user.userAuthClass.rctiWrite || this.$store.state.user.userAuthClass.billingWrite"
                >
                  <v-menu
                    slot="activator"
                    bottom
                    left
                    transition="scale-transition"
                    :close-on-content-click="true"
                    v-model="toolsMenu"
                  >
                    <v-btn flat color="grey" icon slot="activator">
                      <v-icon>check_circle</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        @click="openAddBillsDialog"
                        v-if="this.$store.state.user.userAuthClass.billingWrite"
                      >
                        <v-list-tile-action>
                          <v-icon
                            :color="$store.state.global.pages.billing.color"
                          >{{$store.state.global.pages.billing.icon}}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Create Bills</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <span>Tools</span>
                </v-tooltip>
                <v-menu
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

              <v-alert
                v-if="selected.length >= 10"
                :value="true"
                color="grey lighten-3"
                icon="notification_important"
                style="width: 100%; border-radius: 4px;"
                class="grey--text text--darken-2 py-1"
              >
                <div class="flex-container-center">
                  <span>{{selectedAll ? count : selected.length}} items are selected.</span>
                  <v-btn
                    v-if="selectedAll"
                    @click="selected = []; selectedAll = false;"
                    flat
                    color="grey"
                  >Unselect all {{$vuetify.breakpoint.smAndUp ? `${count} items` : ''}}</v-btn>
                  <v-btn
                    v-else
                    @click="selectedAll = true"
                    flat
                    :color="$store.state.global.pages.billing.color"
                  >Select all {{$vuetify.breakpoint.smAndUp ? `${count} items` : ''}}</v-btn>
                </div>
              </v-alert>
            </v-layout>
          </v-container>

          <v-data-table
            :items="approvedBillLines"
            :headers="headers"
            :pagination.sync="pagination"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :total-items="count"
            v-model="selected"
            :loading="loading"
            select-all
            disable-initial-sort
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">No Bills for the selected criteria.</div>
            </template>
            <template slot="items" slot-scope="props">
              <approved-bill-line-row
                :bill="props.item"
                :value="props.selected"
                :headers="headers"
                @input="toggleSelected"
                :key="props.item.id"
              ></approved-bill-line-row>
            </template>
          </v-data-table>


           <v-container fluid>
            <v-layout row wrap v-if="!!approvedBillLines.length" class="grey--text">
              <v-flex xs12 sm6 md5 lg3>
                
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm4 md3>
                <div>
                  <div
                    class="text-xs-right flex-container-space-between mb-2"
                    v-if="totals.tripTotal && !!userShowCost"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Trip Total:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">${{addCommas(parseFloat(totals.tripTotal).toFixed(4))}}</span>
                    </div>
                  </div>
                  <div
                    class="text-xs-right flex-container-space-between mb-2"
                    v-if="totals.approvedTotal && !!userShowCost"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Approved:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">${{addCommas(Number(totals.approvedTotal).toFixed(4))}}</span>
                    </div>
                  </div>


                  <div
                    class="text-xs-right flex-container-space-between"
                    v-if="!!totals.outstandingTotal && !!userShowSell"
                  >
                    <div>
                      <span class="text-xs-left grey--text text--darken-1 body-2">Outstanding:</span>
                    </div>
                    <div class="ml-2">
                      <span class="text-xs-right">${{addCommas(parseFloat(totals.outstandingTotal).toFixed(4))}}</span>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </transition>

    <v-dialog v-model="addBillsDialog" lazy max-width="700px">
      <add-bills :dialogOpen="addBillsDialog" @close="addBillsDialog = false"></add-bills>
    </v-dialog>

  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
import ApprovedBillLineRow from '@/modules/approvedBillLines/approvedBillLineRow'
import MultiActions from '@/components/trips/actions/multiTripActions'
import AddBills from '@/modules/approvedBillLines/addBills'
import ApprovedBillLineHeaders from '@/modules/approvedBillLines/mixins/approvedBillLineHeaders'
import HeaderFilters from '@/services/mixins/headerFilters'
import { debounce } from 'lodash'
import BillingPeriods from '@/services/mixins/billingPeriods'

export default {
  mixins: [ApprovedBillLineHeaders, HeaderFilters, BillingPeriods],
  components: {
    ApprovedBillLineRow,
    MultiActions,
    AddBills
  },
  props: {
    page: String
  },
  watch: {
    billingPeriod(val) {
      this.getApprovedBillLines()
    },
    billingStatus(val) {
      this.getApprovedBillLines()
    },
    showClosed(val) {
      this.getApprovedBillLines()
    },
    showCreated(val) {
      this.getApprovedBillLines()
    },
    pagination(val) {
      this.getApprovedBillLines()
    },
    projectId(val) {
      this.getApprovedBillLines()
    },
    siteId(val) {
      this.getApprovedBillLines()
    },
    selectedUserId(val) {
      this.getApprovedBillLines()
    },
    dateRangeStart(val) {
      this.getApprovedBillLines()
    },
    dateRangeEnd(val) {
      this.getApprovedBillLines()
    },
    filterBy: debounce(function() {
      this.getApprovedBillLines()
    }, 500)
  },
  data() {
    return {
      color: 'blue',
      searchTerm: '',
      loading: false,
      fieldChooserMenu: false,
      toolsMenu: false,
      addBillsDialog: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        sortBy: null,
        rowsPerPageItems: [10, 20, 40, 50]
      },
      totals: {},
      count: 0
    }
  },
  mounted() {
    if (!!this.$route.query.ids) {
      this.showCreated = true
    } else {
      this.showCreated = false
    }
    this.getApprovedBillLines()
  },
  beforeDestroy() {
    this.approvedBillLines = []
    this.selected = []
  },
  methods: {
    openAddBillsDialog() {
      if (
        !this.projectId ||
        !this.billingPeriod ||
        !this.openBillingPeriods.find(
          billingPeriod => billingPeriod === this.billingPeriod
        )
      ) {
        this.snack({
          color: 'yellow',
          text: 'You must select an open billing period and a project!'
        })
        return
      } else {
        this.addBillsDialog = true
      }
    },
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object)
      } else {
        var index = this.selected.indexOf(val.object)
        this.selected.splice(index, 1)
      }
    },

    getApprovedBillLines() {
      // if (!keepPage) this.pagination.page = 1
      this.loading = true
      const payload = {
        pagination: this.pagination,
        billingPeriod: this.billingPeriod,
        billingStatus: this.billingStatus,
        projectId: this.projectId,
        siteId: this.siteId,
        userId: this.selectedUserId,
        dateRangeStart: this.dateRangeStart,
        dateRangeEnd: this.dateRangeEnd,
        filterCol: this.filterCol,
        filterBy: this.filterBy,
        showClosed: this.showClosed
      }
      ApprovedBillLineService.getApprovedBillLines(payload)
        .then(result => {
          // console.log('RESULT', this.pagination)
          this.approvedBillLines = result.data.result
          this.count = result.data.count
          this.pagination.totalItems = result.data.count
          this.totals = result.data.totals
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    }
  },
  computed: {
    approvedBillLines: Store.getSet({
      store: 'approvedBillLines',
      prop: 'approvedBillLines'
    }),
    filterBy: Store.getSet({ store: 'approvedBillLines', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'approvedBillLines', prop: 'filterCol' }),
    dates: Store.getSet({ store: 'approvedBillLines', prop: 'dates' }),
    selected: Store.getSet({ store: 'approvedBillLines', prop: 'selected' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    billingStatus: Store.getSet({ store: 'shared', prop: 'billingStatus' }),
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    showCreated: Store.getSet({ store: 'shared', prop: 'showCreated' }),
    selectedAll: Store.getSet({
      store: 'approvedBillLines',
      prop: 'selectedAll'
    }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems
      } else {
        return this.selected.length
      }
    },
    headers() {
      var actions = {
        text: 'Actions',
        align: 'center',
        value: '',
        sortable: false,
        colData: '',
        type: 'action'
      }

      var tempArray = this.filterHeaders()
      tempArray.push(actions)
      return tempArray
    }
  }
}
</script>

<style>
</style>
